import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
    root: {
        marginRight: 16,
        '@media(max-width: 768px)': {
            marginRight: 0,
        }
    },
    searchIcon: {
        width: 23.64,
        height: 23.64,
        cursor: "pointer"
    }
});